import React from 'react';

const SI = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_45"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_45)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#0268AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#EF1F28"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="white"
      />
      <path
        d="M6.5 3H4.5C3.94772 3 3.5 3.44772 3.5 4V6.5C3.5 7.05228 3.94772 7.5 4.5 7.5H6.5C7.05228 7.5 7.5 7.05228 7.5 6.5V4C7.5 3.44772 7.05228 3 6.5 3Z"
        fill="#EF1F28"
      />
      <path
        d="M6 3H5C4.44772 3 4 3.44772 4 4V6C4 6.55228 4.44772 7 5 7H6C6.55228 7 7 6.55228 7 6V4C7 3.44772 6.55228 3 6 3Z"
        fill="#0268AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4H6V5H5V4Z"
        fill="#FFE200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6L5.5 5.5L7 6L6 7H5L4 6Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SI;
